<div
  class="procedure"
  [ngClass]="{'edit': currentObjectService.isEditing}"
>
  @if (!currentObjectService.isEditing) {
    <div class="procedure__search-menu">
      <app-object-search-menu
        class="procedure__search-menu-content"
        [object]="operationContainer?.rootSectionsContainer?.rootObject"
        [isEditing]="currentObjectService.isEditing"
        [stylingClass]="'sp-procedure-page'"
      ></app-object-search-menu>

      @if (newLayout) {
        <div class="procedure__search-menu__navigation">
          <app-object-page-search-navigation
            slot="search-navigation"
            [artifactId]="artifactId"
            [searchContext]="currentSearchContext"
            (closeClick)="onCloseClick()"
          />
        </div>
      }

      <div class="procedure__template">
        <div class="procedure__template-button">
          @if (operationContainer?.contentInfo?.artifact) {
            <app-template-group-select-button
              [object]="operationContainer.contentInfo.artifact"
              [collapseOnSmallScreen]="false"
              (templateSelectorCreated)="onTemplateSelectorCreated($event)"
              (changeTemplateGroup)="onChangeTemplateGroup($event)"
              [templateGroupId]="operationContainer.contentInfo.templateGroupId"
              [disabled]="currentObjectService.isEditing"
            ></app-template-group-select-button>
          }
        </div>
      </div>
    </div>
  }

  @if (operationContainer?.selectorEnabled && !operationContainer?.currentOperation?.$$operationDialog) {
    <app-search-view-selector
      class="procedure__selector"
      [ngClass]="{'dialogOpen': operationContainer.inModal}"
      [modalIsOpen]="operationContainer.inModal"
      [selectorContainer]="operationContainer"
    ></app-search-view-selector>
  }

  @if (templateSelectorContainer.selectorEnabled) {
    <app-search-view-selector
      class="procedure__selector"
      [selectorContainer]="templateSelectorContainer"
    ></app-search-view-selector>
  }

  @if (showImageOrder) {
    <div class="side-selector change-img-order-selector procedure__change-image-order-selector">
      @if (operationContainer.rootSectionsContainer.rootObject && operationContainer.rootSectionsContainer.rootObject.$$mediaContainer?.mediaTypes.length) {
        <app-change-media-order
          [mediaContainer]="operationContainer.rootSectionsContainer.rootObject.$$mediaContainer"
          [sectionsContainer]="operationContainer.rootSectionsContainer"
          (toggleChangeMediaOrder)="onToggleChangeImageOrder()"
        ></app-change-media-order>
      }
    </div>
  }

  <div class="procedure__content">
    <div class="procedure__top">
      <div
        class="procedure__top-fields"
        [@showAllFields]="showAllFieldInformation || currentObjectService.isEditing ? 'openTop' : 'closedTop'"
      >
        @if (operationContainer?.rootSectionsContainer?.rootObject) {
          <app-procedure-view-and-edit
            [isEditing]="currentObjectService.isEditing"
            [showALLFields]="showAllFieldInformation"
            [operationContainer]="operationContainer"
            class="procedure__top-content"
          ></app-procedure-view-and-edit>
        }

        @if (noProcedureId) {
          <span>
            {{ 'TRANS__PROCEDURE__UNABLE_TO_FIND_PROCEDURE' | translate }}
          </span>
        }
      </div>

      @if (!currentObjectService.isEditing) {
        <a
          class="toggleProcedureFields"
          (click)="toggleFieldInformation()"
          [ngClass]="{'disable-button': currentObjectService.isEditing}"
        >
          <div class="toggleProcedureFields__container">
            <div class="toggleProcedureFields__content text-blue-hover">
              <mat-icon>
                {{showAllFieldInformation ? 'expand_less' : 'expand_more'}}
              </mat-icon>
            </div>
          </div>
        </a>
      }
    </div>

    @if (!currentObjectService.isEditing) {
      <div class="procedure__lower">
        <div
          class="procedure__vertical-menu"
          [@showContentMenu]="smallScreen ? (openMenu ? 'expandMenu' : 'collapseMenu') : 'expandMenu'"
        >
          @if (loadingProcedureInfo) {
            <div class="loading-operation-selector-vertical"></div>
          }
          @else {
            @if (operationContainer) {
              <app-operation-selector-vertical
                [operationContainer]="operationContainer"
                [editContent]="currentObjectService.isEditing"
                [contentList]="operationContainer.contentInfo.curListName"
                [smallScreen]="smallScreen"
                (selectOperation)="onSelectOperation($event)"
              ></app-operation-selector-vertical>
            }
          }
        </div>

        <div
          class="procedure__lower-content"
          [@showContentMenu]="smallScreen && openMenu"
        >
          @if (loadingProcedureInfo) {
            <div class="procedure__loading-content">
              <div class="procedure__loading-content-text-container">
                <mat-spinner
                  color="accent"
                  diameter="40"
                ></mat-spinner>

                <span>
                  {{  'TRANS__EDIT_FIELD_SELECT__HIERARCHY__LOADING' | translate }}
                </span>
              </div>
            </div>
          }
          @else {
            @if (operationContainer?.contentInfo && operationContainer?.currentOperation) {
              <ng-container>
                @if (operationContainer?.contentInfo.curListName === 'spectrum_procedure_object') {
                  <ng-container>
                    <div class="procedure__content-headline">
                      <div class="procedure__title">
                        @if (smallScreen) {
                          <a
                            (click)="onToggleMenu()"
                            class="procedure__toggle-button"
                          >
                            <mat-icon>
                              {{openMenu ? 'menu_open' : 'menu'}}
                            </mat-icon>
                          </a>
                        }

                        @if (operationContainer.contentInfo.selectedMainMenu) {
                          <h3>
                            <span class="bold">
                              {{ operationContainer.contentInfo.selectedMainMenu['caption'] | translate }}
                            </span>
                          </h3>
                        }
                      </div>

                      <app-operation-menus-two-levels
                        class="procedure__operation-buttons"
                        [operationContainer]="operationContainer"
                        [parentOperation]="operationContainer.currentOperation"
                      ></app-operation-menus-two-levels>

                      <app-procedure-content-view-selector
                        class="procedure__operation-selector"
                        [currentProcedureContentViewName]="currentProcedureContentViewName"
                        (viewSelected)="onSelectView($event)"
                      ></app-procedure-content-view-selector>
                    </div>

                    @if (currentProcedureStep && currentProcedureContentViewName === 'steps') {
                      <div class="procedure__stepper">
                        <app-procedure-stepper
                          [procedureSteps]="procedureSteps"
                          [currentProcedureStep]="currentProcedureStep"
                          [operationContainer]="operationContainer"
                          [isEditing]="currentObjectService.isEditing"
                          (stepSelected)="onStepSelected($event)"
                        ></app-procedure-stepper>
                      </div>
                    }

                    <hr class="procedure__line">

                    @if (currentProcedureContentViewName === 'steps') {
                      <div class="procedure__second-title">
                        @if (operationContainer.contentInfo.selectedMainMenu) {
                          <h2 class="bold">
                            <span>
                              {{count}} &nbsp;
                            </span>

                            <span>
                              {{contentListHeadline}}
                            </span>
                          </h2>
                        }
                      </div>
                    }
                  </ng-container>
                }

                @if (operationContainer.contentInfo.curContentListSource) {
                  <app-procedure-content-list-source
                    [isEditing]="currentObjectService.isEditing"
                    [smallScreen]="smallScreen"
                    [operationContainer]="operationContainer"
                    [openMenu]="openMenu"
                    (toggleChangeImageOrder)="onToggleChangeImageOrder()"
                    (toggleMenu)="onToggleMenu()"
                    (procedureLoad)="loadProcedure()"
                  ></app-procedure-content-list-source>
                }
                @else {
                  <app-procedure-content-list
                    [isEditing]="currentObjectService.isEditing"
                    [smallScreen]="smallScreen"
                    [operationContainer]="operationContainer"
                    [openMenu]="openMenu"
                    (toggleMenu)="onToggleMenu()"
                    (procedureLoad)="loadProcedure()"
                  ></app-procedure-content-list>
                }
              </ng-container>
            }
          }
        </div>
      </div>
    }
  </div>

  @if (currentObjectService.isEditing) {
    <div class="object-page__action-toolbar">
      @if (operationContainer?.currentOperation?.$$currentStep) {
        <app-operation-toolbar
          [operationContainer]="operationContainer"
          [operationStep]="operationContainer.currentOperation?.$$currentStep"
        ></app-operation-toolbar>
      }
    </div>
  }

  @if (operationContainer?.selectorEnabled || templateSelectorContainer.selectorEnabled) {
    <div
      class="overlay"
      (click)="selectorOverlay()"
      (keydown)="null"
      [ngClass]="{'dialogOpen': operationContainer.inModal}"
    ></div>
  }

  @if (operationContainer?.rootSectionsContainer?.rootObject?.$$mediaContainer && showImageOrder) {
    <div
      class="overlay"
      (click)="onToggleChangeImageOrder()"
      (keydown)="null"
    ></div>
  }
</div>

